import API from './api';

export const announcementService = {
  // Get all announcements
  getAnnouncements: (params) => API.get('/announcements', { params }),
  
  // Get announcement count for bell notification
  getAnnouncementCount: () => API.get('/announcements/count'),
  
  // Get single announcement
  getAnnouncementById: (id) => API.get(`/announcements/${id}`),
  
  // Create new announcement (Admin/HR only)
  createAnnouncement: (data) => API.post('/announcements', data),
  
  // Update announcement (Admin/HR only)
  updateAnnouncement: (id, data) => API.put(`/announcements/${id}`, data),
  
  // Delete announcement (Admin/HR only)
  deleteAnnouncement: (id) => API.delete(`/announcements/${id}`),
};